module.exports = "kan-contract .kan-contract-container {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #ffffff;\n  z-index: 100; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/services/components/contract/component.scss
// module id = ./src/modules/services/components/contract/component.scss
// module chunks = main